import { TERMS } from '../sections/home/copy';
import PageShell from '../sections/home/PageShell';
import LegalLayout from '../sections/legal/LegalLayout';

// ----------------------------------------------------------------------

export default function TermsPage() {
  return (
    <PageShell head={TERMS.head}>
      <LegalLayout doc={TERMS} />
    </PageShell>
  );
}
